import { contact, images } from '../data';

const ctaProps = {
  href: contact.schedulingHref,
  target: '_blank',
  rel: 'noopener noreferrer',
};

export default function Contact() {
  return (
    <section className="section contact" id="contact">
      <div className="container contact-grid">
        <div className="contact-copy" data-reveal>
          <p className="eyebrow">Get in touch</p>
          <h2 className="display-2">
            Let’s get your <em>books handled.</em>
          </h2>
          <p className="lede">
            Tell us a little about your business and what you need help with. We’ll figure out the
            right place to start.
          </p>
          <a className="btn btn-primary btn-lg" {...ctaProps}>
            Get Started
          </a>

          <dl className="contact-details">
            <div>
              <dt>Email</dt>
              <dd>
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </dd>
            </div>
            <div>
              <dt>Phone</dt>
              <dd>
                <a href={contact.phoneHref}>{contact.phone}</a>
              </dd>
            </div>
            <div>
              <dt>Scheduling</dt>
              <dd>
                <a href={contact.schedulingHref} target="_blank" rel="noopener noreferrer">
                  {contact.scheduling}
                </a>
              </dd>
            </div>
            <div>
              <dt>Location</dt>
              <dd>{contact.location}</dd>
            </div>
          </dl>
        </div>

        <figure className="contact-media" data-reveal>
          <img src={images.contact} alt="A small business storefront on a bright morning" loading="lazy" />
        </figure>
      </div>
    </section>
  );
}
